export default __webpack_public_path__ + "static/media/notesoverlap.1c8f2e16.png";